import React, { useRef } from 'react'

import Image from 'next/image'

import { useScroll, useTransform } from 'framer-motion'

import {
  BackgroundImageHolder,
  IconImageContainer,
  IconImageHolder,
  MediaHolder,
} from './styles'

import { EmajinSectionQuestionItem } from '../constants'

const BACKGROUND_SIZES = [270, 270, 300, 400, 400, 480]
const ICON_IMAGE_SIZES = [320, 320, 350, 460, 460, 550]

type Props = {
  item?: EmajinSectionQuestionItem
}

function EmajinSectionQuestionsMediaHolder({ item }: Props) {
  const ref = useRef(null)

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })

  const rotateZ = useTransform(scrollYProgress, [0, 1], [-90, 0])

  if (!item) return null

  return (
    <MediaHolder width={[1, 1, 1, 1, 1 / 2]}>
      <BackgroundImageHolder height={BACKGROUND_SIZES} width={BACKGROUND_SIZES}>
        <Image
          alt={item.backgroundImageAlt}
          height={item.backgroundImage.height}
          src={item.backgroundImage}
          width={item.backgroundImage.width}
        />
      </BackgroundImageHolder>

      <IconImageContainer height={ICON_IMAGE_SIZES} width={ICON_IMAGE_SIZES}>
        <IconImageHolder ref={ref} style={{ rotateZ }}>
          <Image
            alt={item.iconImageAlt}
            height={item.iconImage.height}
            src={item.iconImage}
            width={item.iconImage.width}
          />
        </IconImageHolder>
      </IconImageContainer>
    </MediaHolder>
  )
}

export default EmajinSectionQuestionsMediaHolder
